import React from "react";
import Desktop1 from "./components/Desktop1";

function App() {
  return <Desktop1 />;
}

export default App;
